import script from "./InputDatepicker.vue?vue&type=script&setup=true&lang=js"
export * from "./InputDatepicker.vue?vue&type=script&setup=true&lang=js"

import "./InputDatepicker.vue?vue&type=style&index=0&id=b146e8d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b146e8d8"]])

export default __exports__